import React from 'react';
import {Spinner} from '@wix/wix-ui-tpa/cssVars';
import {useLocaleKeys} from '../../../locale-keys/LocaleKeys';
import {SkipCheckoutFlowStatus} from '../../../types/checkoutApp.types';
import {classes} from './SkipCheckoutLayout.st.css';

export enum SkipCheckoutLayoutDataHooks {
  root = 'SkipCheckoutLayout.root',
  spinner = 'SkipCheckoutLayout.spinner',
  message = 'SkipCheckoutLayout.message',
}

export interface SkipCheckoutLayoutProps {
  status: SkipCheckoutFlowStatus.FetchingData | SkipCheckoutFlowStatus.PlacingOrder;
}

export const SkipCheckoutLayout = ({status}: SkipCheckoutLayoutProps) => {
  const localeKeys = useLocaleKeys();
  const message =
    status === SkipCheckoutFlowStatus.PlacingOrder
      ? localeKeys.checkout.fastComplete.completingOrder.loader.title()
      : localeKeys.checkout.fastComplete.evaluating.loader.title();

  return (
    <div data-hook={SkipCheckoutLayoutDataHooks.root} className={classes.root}>
      <Spinner data-hook={SkipCheckoutLayoutDataHooks.spinner} isCentered={true} />
      <span data-hook={SkipCheckoutLayoutDataHooks.message} className={classes.message}>
        {message}
      </span>
    </div>
  );
};
